import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContactInfoValidationService } from '../services/validation-service';
import { ValidateOnBlurDirective } from './validate-on-blur.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ValidateOnBlurDirective],
  exports: [ValidateOnBlurDirective],
  providers: [ContactInfoValidationService]
})
export class ValidationOnBlurModule {}
